import merge from 'lodash-es/merge';

export let Options = {
    animations: {
        disabled: false,
        markers: false
    }
}

export function setOptions(newOptions) {

    merge(Options, newOptions);
    console.debug("PCT App initialize with options", Options);
}